import { CustomBox } from "components/Box/CustomBox";
import React from "react";
import { cycleSelector } from "./selectorCycles";
import { useDispatch, useSelector } from "react-redux";
import { CycleRow } from "./CycleRow";
import { Grid } from "@material-ui/core";
import { CustomerCycleForm } from "./CustomerCycleForm";
import { selectCustomerCycle } from "redux/actions/customers/customersAction";
import { getCustomerProducts } from "redux/actions/customers/customersAction";
import RegularButton from "components/CustomButtons/Button";
import { activeAddCycleMode } from "redux/actions/customers/customersAction";

export const CyclesList = () => {
  const cycles = useSelector(cycleSelector) || [];
  const { addCycleMode, cycle } = useSelector(
    ({ customersReducer }) => customersReducer
  );
  const dispatch = useDispatch();
  
  const handleSelectCycle = (cl) => {
    dispatch(selectCustomerCycle(cl));
    dispatch(getCustomerProducts(cl.id));
  };

  const handleCycleMode = () => {
    dispatch(activeAddCycleMode());
  };
  return (
    <CustomBox title="Lista de Ciclos" style={{ minHeight: "90%" }}>
      <RegularButton
        round
        justIcon
        color="info"
        tooltip="Nuevo Ciclo"
        onClick={handleCycleMode}
        style={{ float: "right" }}
      >
        +
      </RegularButton>
      <Grid container spacing={1}>
        <Grid
          item
          xs={12}
          sm={addCycleMode ? 4 : 6}
          style={{
            height: "55vh",
            overflow: "hidden",
            padding: "24px 0",
            paddingRight: 4,
            overflowY: "scroll",
            transition: ".3s ease",
            pointerEvents: addCycleMode ? "none" : "auto",
            opacity: addCycleMode ? 0.3 : 1,
          }}
        >
          <Grid container spacing={3}>
            {cycles?.map((cycleData, index) => (
              <CycleRow
                key={cycleData.cycle?.id || `cycle-${cycleData.id}-${index}`}
                data={cycleData}
                onClick={handleSelectCycle}
              />
            ))}
          </Grid>
        </Grid>
        <Grid
          item
          xs={12}
          sm={addCycleMode ? 8 : 6}
          style={{
            pointerEvents:
              addCycleMode || Object.keys(cycle).length > 0 ? "auto" : "none",
            opacity: !addCycleMode && Object.keys(cycle).length === 0 ? 0.3 : 1,
          }}
        >
          <CustomerCycleForm />
        </Grid>
      </Grid>
    </CustomBox>
  );
};
